import { axiosNodeInstance } from "../../../adapters/axiosInstance";
import {
    GET_VENDOR_AND_BOXIGO_MARGIN,
    CREATE_VENDOR_AND_BOXIGO_MARGIN,
    UPDATE_VENDOR_AND_BOXIGO_MARGIN
} from "./marginTypes";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getVendorBoxigoMarginRecord = createAsyncThunk(GET_VENDOR_AND_BOXIGO_MARGIN, async ({ estimate_id, vendor_id }) => {
    const response = await axiosNodeInstance.get(`get/estimate/${estimate_id}/vendor/${vendor_id}/vendor_boxigo_margin`);
    return response.data;
});

export const createVendorBoxigoMarginRecord = createAsyncThunk(CREATE_VENDOR_AND_BOXIGO_MARGIN, async (input) => {
    await axiosNodeInstance.post("create/vendor_boxigo_margin", input);
    const response = await axiosNodeInstance.get(`get/estimate/${input.estimate_id}/vendor/${input.vendor_id}/vendor_boxigo_margin`);
    return response.data;
});

export const updateVendorBoxigoMarginRecord = createAsyncThunk(UPDATE_VENDOR_AND_BOXIGO_MARGIN, async (input) => {
    await axiosNodeInstance.post("update/vendor_boxigo_margin", input);
    const response = await axiosNodeInstance.get(`get/estimate/${input.estimate_id}/vendor/${input.vendor_id}/vendor_boxigo_margin`);
    return response.data;
});

